import { useEffect, useRef, useState } from "react";
import Trainers from "../components/Trainers";
import Outcomes from "../components/Outcomes";

import LiveProjectSection from "../components/Liveprojectsection";
import CertificateOutcomeSection from "../components/Certificateoutcomesection";
import DesignedForPractice from "../components/DesignedForPractice";

/* ----------------------------------------------------------------------
   Course Overview — Data
   ---------------------------------------------------------------------- */

const COURSES = [
  {
    key: "careerCounselling",
    name: "Career Counselling and Guidance",
    price: 4999,
    icon: "compass",
    blocks: [
      { title: "Program structure", plain: true, items: ["Career Counselling", "Career Guidance"] },
      {
        title: "Course Objectives",
        plain: false,
        items: [
          "Make the candidates know their own self",
          "Enhance their inner core strengths, minimize weaknesses, and identify interests",
          "Guidance for choosing the correct path in career",
          "Direction to use the acquired strength in the right direction",
          "Prevent one from work-related stress",
        ],
      },
    ],
  },
  {
    key: "softSkills",
    name: "Soft Skills Development",
    price: 9999,
    icon: "users",
    blocks: [
      {
        title: "Program structure",
        plain: true,
        items: [
          "Improve Communication and Self-Marketing skills",
          "Enhance Interactive Skills",
          "Build a Positive Competitive attitude",
          "Induce right Work Ethics",
          "Build Human Relations",
          "Learn Time Management",
        ],
      },
    ],
  },
  {
    key: "architectureDrawings",
    name: "Architecture Drawings and Services Standards",
    price: 19999,
    icon: "ruler",
    blocks: [
      {
        title: "Program structure",
        plain: true,
        items: [
          "Auto CAD Drafting Standards",
          "Introduction to Types of Drawing for building execution",
          "Working Drawings standards",
          "Folder Management",
          "Virtual Tour for explaining On-site execution",
        ],
      },
      {
        title: "Services",
        plain: false,
        items: [
          "In-depth understanding of Building Services and their varied functions",
          "A. Electrical",
          "B. Mechanical",
          "C. Plumbing",
          "Basic consideration of services and how to implement them in their design",
          "Preparing service drawings",
          "On-site and off-site Consultant coordination.",
        ],
      },
      {
        title: "Course Objectives",
        plain: false,
        items: [
          "Renewed confidence in your technical drawing skills.",
          "To learn technical drawings as per industry standards.",
          "To understand onsite execution problems and their solution",
          "To understand services and learn to produce their drawings",
          "To understand various types of services and consultant teams' coordination",
          "To understand onsite execution problems and work out solutions",
        ],
      },
    ],
  },
  // "Advance Architecture Softwares" is rendered separately (custom nested list)
  {
    key: "aiRender",
    name: " Architecture AI Software",
    price: 14999,
    icon: "spark",
    blocks: [
      {
        title: "Program structure",
        plain: true,
        items: ["A. Enscape", "B. D5 Render", "C. Nano Banana"],
      },
    ],
  },
  {
    key: "advanceConstruction",
    name: "Advance Construction Technologies and Materials",
    price: 14999,
    icon: "brick",
    blocks: [
      {
        title: "Program structure",
        plain: true,
        items: [
          "Introduction to Current Construction Technologies and Trends",
          "Introduction to Latest construction materials",
          "Role of materials in a building envelope",
          "A brief introduction to LEED certifications",
          "A brief overview of Sustainable building materials",
        ],
      },
      {
        title: "Course Objectives",
        plain: false,
        items: [
          "To develop knowledge about new construction techniques and materials",
          "To improve overall design skills",
          "To create an awareness of sustainable development in the industry",
          "To initiate the process of innovative thinking ability with the help of different materials and advanced technologies",
        ],
      },
    ],
  },
  {
    key: "nbc",
    name: "NBC and Liasoning",
    price: 14999,
    icon: "shield",
    blocks: [
      {
        title: "Program structure",
        plain: true,
        items: [
          "A brief introduction about NBC",
          "Fire norms",
          "Liasoning",
          "Building permission & required documents",
          "Development plan",
          "Regional plan",
          "List of documents required for sanction process",
          "Guidelines to read legal documents",
          "Know-how's of Sanction process",
          "Provide a brief understanding of Purpose and need of various documents",
          "Types of NOC",
        ],
      },
      {
        title: "Course Objectives",
        plain: false,
        items: [
          "Awareness of NBC (National Building Code) Standards",
          "Importance of National and International Building Codes in Architectural Practice",
          "To improve Design Skills",
          "Awareness of Building Bylaws",
          "Importance of Building Bylaws",
        ],
      },
    ],
  },
  {
    key: "placement",
    name: "Placement assistance",
    price: 1999,
    icon: "briefcase",
    blocks: [
      {
        title: "Program structure",
        plain: true,
        items: [
          "An Introduction about Live Project and its Management",
          "Interactions with Site-coordinators",
          "Involvement in Live Projects",
          "Working Drawings",
          "Coordination between various Consultants",
          "Service Layouts and Drawings",
        ],
      },
      {
        title: "Course Objectives",
        plain: false,
        items: [
          "To provide hands-on experience to the candidates",
          "To make the candidate technically sound",
          "To offer a real-time experience of how a project works",
          "To build Confidence to handle project and people on site from scratch to end",
          "To train candidates to work on a project single-handedly from start to end",
        ],
      },
    ],
  },
];

// Software options are rendered as individual cards so each tool can be
// selected independently with its own checkbox column.
const SOFTWARES = [
  { id: "revit", name: "Advance Revit Architecture", subtitle: "BIM Modeling", price: 19999, icon: "revit" },
  { id: "navisworks", name: "Navisworks", subtitle: "Model Coordination", price: 19999, icon: "navisworks" },
  { id: "autocad", name: "Auto-CAD (Drafting Standards)", subtitle: "Drafting Standards", price: 9999, icon: "autocad" },
  { id: "rhino", name: "Rhinoceros", subtitle: "Parametric Modeling", price: 10999, icon: "rhino" },
  { id: "grasshopper", name: "Grasshopper", subtitle: "Algorithmic Design", price: 9999, icon: "grasshopper" },
  { id: "globalmapper", name: "Global Mapper", subtitle: "Terrain & Mapping", price: 9999, icon: "globalmapper" },
  { id: "sketchup", name: "Sketchup", subtitle: "3D Modeling", price: 7499, icon: "sketchup" },
  { id: "enscape", name: "Enscape", subtitle: "Real-time Rendering", price: 7499, icon: "enscape" },
  { id: "arcgis", name: "ArcGIS", subtitle: "Spatial Analysis", price: 9999, icon: "arcgis" },
  { id: "primavera", name: "Primavera", subtitle: "Project Scheduling", price: 14999, icon: "primavera" },
];

const AI_SOFTWARES = [
  { id: "enscape", name: "Enscape", subtitle: "Real-time Rendering", price: 14999, icon: "enscape" },
  { id: "d5render", name: "D5 Render", subtitle: "Visualization", price: 14999, icon: "d5render" },
  { id: "nano", name: "Nano Banana", subtitle: "AI-assisted Creativity", price: 14999, icon: "nano" },
];

const SOFTWARE_PACKAGE_PRICE = 59999;
const MAX_SOFTWARE_PICKS = 5;

// Category grouping for the main software picker UI.
const SOFTWARE_GROUPS = [
  { category: "Building Information Modeling (BIM)", icon: "bim", ids: ["revit", "navisworks"] },
  { category: "Drafting & Documentation", icon: "draft", ids: ["autocad"] },
  { category: "Computational Design", icon: "computational", ids: ["rhino", "grasshopper"] },
  { category: "Urban Planning & GIS", icon: "globe", ids: ["globalmapper", "arcgis"] },
  { category: "Visualization & Presentation", icon: "eye", ids: ["sketchup", "enscape"] },
  { category: "Project Management", icon: "pm", ids: ["primavera"] },
];

// Category header icon — same set used on the Interior Designer page.
function SwCategoryIcon({ type }) {
  const p = {
    bim: <path d="M4 21V8l8-5 8 5v13M9 21v-7h6v7M4 8l8 5 8-5" />,
    spark: (
      <>
        <path d="M12 3l1.8 5.6L19 10l-5.2 1.9L12 17l-1.8-5.1L5 10l5.2-1.4L12 3z" />
      </>
    ),
    eye: (
      <>
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
    computational: (
      <>
        <circle cx="6" cy="6" r="2.4" />
        <circle cx="18" cy="6" r="2.4" />
        <circle cx="12" cy="18" r="2.4" />
        <path d="M8 7l7 0M7.5 8.2L11 16M16.5 8.2L13 16" />
      </>
    ),
    draft: (
      <>
        <path d="M3 16.5L16.5 3 21 7.5 7.5 21 3 16.5z" />
        <path d="M7 12.5l2 2M10 9.5l2 2M13 6.5l2 2" />
      </>
    ),
    pm: (
      <>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 9h18M8 13h5M8 17h8" />
      </>
    ),
    // ── generic block-header icons used for Program structure /
    // Course Objectives / Services / any other plain item block ──
    list: <path d="M4 6h16M4 12h10M4 18h13" />,
    target: (
      <>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="4.5" />
        <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
      </>
    ),
    layers: (
      <>
        <path d="M12 3l9 5-9 5-9-5 9-5z" />
        <path d="M3 13l9 5 9-5" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      {p[type] ?? p.bim}
    </svg>
  );
}

// Generic block headings (Program structure, Course Objectives, Services…)
// are rendered with the same category-header treatment as the software
// groups. This maps a heading to the icon used in that header.
function blockIconType(title) {
  if (title === "Course Objectives") return "target";
  if (title === "Services") return "layers";
  return "list";
}

// Per-tool icon — same set used on the Interior Designer page, plus a
// "globalmapper" glyph (a map pin) since that tool isn't on that page.
function SwToolIcon({ type }) {
  const p = {
    revit: <path d="M4 20V6l8-3 8 3v14M8 20v-6h8v6M4 10h16" />,
    autocad: (
      <>
        <path d="M4 20L14 4l6 16" />
        <path d="M8 14h9" />
      </>
    ),
    sketchup: <path d="M4 8l8-5 8 5-8 5-8-5zM4 8v8l8 5V13M20 8v8l-8 5" />,
    arcgis: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
    primavera: (
      <>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 9h18M8 13h5M8 17h8" />
      </>
    ),
    rhino: <path d="M6 4v16M6 4l10 4-10 4M6 12l10 4-10 4" />,
    grasshopper: (
      <>
        <circle cx="6" cy="6" r="2.2" />
        <circle cx="18" cy="6" r="2.2" />
        <circle cx="12" cy="18" r="2.2" />
        <path d="M8 6.5h8M7.7 7.8L11.5 16M16.3 7.8L12.5 16" />
      </>
    ),
    globalmapper: (
      <>
        <path d="M12 21s7-7.4 7-12a7 7 0 1 0-14 0c0 4.6 7 12 7 12z" />
        <circle cx="12" cy="9" r="2.3" />
      </>
    ),
    navisworks: (
      <>
        <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
        <path d="M4 7.5L12 12l8-4.5M12 12v9" />
      </>
    ),
   
enscape: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
      </>
    ),
    d5render: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M10 8l6 4-6 4V8z" />
      </>
    ),
    nanobanana: <path d="M4 20l3-1 11-11a2 2 0 0 0-3-3L4 16l-1 4z" />,
    arcgis: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),

  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {p[type] ?? p.revit}
    </svg>
  );
}

// Icon chip tint per tool, same palette used on the Interior Designer page.
const SW_ICON_THEME = {
  revit: { bg: "rgba(59,130,246,0.12)", fg: "#2f6fed" },
  autocad: { bg: "rgba(239,68,68,0.12)", fg: "#e0362b" },
  sketchup: { bg: "rgba(59,130,246,0.12)", fg: "#2f6fed" },
  arcgis: { bg: "rgba(16,185,129,0.12)", fg: "#1f9d55" },
  primavera: { bg: "rgba(59,130,246,0.12)", fg: "#2f6fed" },
  rhino: { bg: "rgba(120,113,108,0.14)", fg: "#57534e" },
  grasshopper: { bg: "rgba(16,185,129,0.12)", fg: "#1f9d55" },
  globalmapper: { bg: "rgba(20,184,166,0.14)", fg: "#0f9488" },
  navisworks: { bg: "rgba(16,185,129,0.12)", fg: "#1f9d55" },
  enscape: { bg: "rgba(249,115,22,0.12)", fg: "#ea580c" },
d5render: { bg: "rgba(147,51,234,0.12)", fg: "#7c3aed" },
nano: { bg: "rgba(234,179,8,0.14)", fg: "#f6d30e" },
  // enscape: { bg: "rgba(147,51,234,0.12)", fg: "#7c3aed" },
  // d5render: { bg: "rgba(249,115,22,0.12)", fg: "#c2410c" },
  // nano: { bg: "rgba(14,165,233,0.12)", fg: "#0369a1" },
};

const fmtINR = (n) => `${n.toLocaleString("en-IN")} INR`;

/* ----------------------------------------------------------------------
   Course Overview —
   ---------------------------------------------------------------------- */
function CoModuleIcon({ type }) {
  const p = {
    compass: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M15 9l-2.2 5.3L7.5 16.5l2.2-5.3L15 9z" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 20v-1.6A4 4 0 0 1 7.5 14.4h3A4 4 0 0 1 14.5 18.4V20" />
        <path d="M16.5 6.4a3.2 3.2 0 0 1 0 6.2M18 20v-1.6a4 4 0 0 0-2.2-3.5" />
      </>
    ),
    ruler: (
      <>
        <path d="M3 16.5L16.5 3 21 7.5 7.5 21 3 16.5z" />
        <path d="M7 12.5l2 2M10 9.5l2 2M13 6.5l2 2" />
      </>
    ),
    cube: (
      <>
        <path d="M12 2.8l8.5 4.6v9.2L12 21.2 3.5 16.6V7.4L12 2.8z" />
        <path d="M3.5 7.4L12 12l8.5-4.6M12 12v9.2" />
      </>
    ),
    spark: (
      <>
        <path d="M12 3l1.8 5.6L19 10l-5.2 1.9L12 17l-1.8-5.1L5 10l5.2-1.4L12 3z" />
      </>
    ),
    brick: (
      <>
        <rect x="3" y="5" width="18" height="5" />
        <rect x="3" y="14" width="18" height="5" />
        <path d="M9 5v5M15 14v5" />
      </>
    ),
    shield: (
      <>
        <path d="M12 3l7 3v5.5c0 4.3-3 7.7-7 9.5-4-1.8-7-5.2-7-9.5V6l7-3z" />
        <path d="M9 12l2.2 2.2L15.5 10" />
      </>
    ),
    briefcase: (
      <>
        <rect x="3" y="7.5" width="18" height="12" rx="1.5" />
        <path d="M9 7.5V5.5h6v2M3 12.5h18" />
      </>
    ),
  };
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      {p[type] ?? p.compass}
    </svg>
  );
}

// Toggle glyph — same plus-that-rotates-into-a-cross used by the toggle
// button in the Course Structure accordion.
function CoToggleIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

// "A. Xxx" / "B. Xxx" sub-items get a plain marker instead of a checkmark
// icon chip, and stack across the full row — same rule used on the
// Architecture / Interior Designer pages' Course Structure section.
const isSubItem = (t) => /^[A-Z]\.\s/.test(t);

// Renders a single course block ("Program structure" / "Course
// Objectives" / "Services" / etc.) using the same category-header +
// 2-column card-grid treatment as the Course Structure section on the
// Architecture and Interior Designer pages — an icon chip + title + rule
// line up top, then a grid of checkmark item cards below.
function ProgramBlock({ block }) {
  return (
    <div className="pb-groups">
      <div className="pb-category">
        {block.title && (
          <div className="pb-cat-header">
            <span className="pb-cat-icon" aria-hidden="true">
              <SwCategoryIcon type={blockIconType(block.title)} />
            </span>
            <span className="pb-cat-title">{block.title}</span>
            {/* <span className="pb-cat-line" /> */}
          </div>
        )}
        <div className="pb-grid">
          {block.items.map((item, i) => {
            const sub = isSubItem(item);
            return (
              <div className={`pb-card${sub ? " sub" : ""}`} key={i}>
                {!sub && (
                  <span className="pb-card-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4.5 12.5l4.5 4.5L19.5 6.5" />
                    </svg>
                  </span>
                )}
                <span className="pb-card-text">{item}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

/* ----------------------------------------------------------------------
   Course Overview — design tokens (was components/course-overview.css)
   Injected inline so the whole builder ships from this one file.
   ---------------------------------------------------------------------- */

const COURSE_OVERVIEW_CSS = `
.co {
  --bg: var(--paper, #f4f1ea);
  --card: #ffffff;
  --border: var(--sand, #e6dfd0);
  --ink: var(--charcoal, #1c1b19);
  --muted: var(--stone, #78736a);
  --accent: var(--terra, #c2591c);
  --accent-dark: var(--terra-lt, #a04a17);
  --accent-soft: rgba(194, 89, 28, 0.1);
  --dark: var(--charcoal, #1c1b19);
  --radius-lg: 16px;
  --radius-md: 10px;
  --radius-sm: 6px;
  --shadow: 0 1px 2px rgba(18,19,15,0.04), 0 12px 32px -16px rgba(18,19,15,0.14);
  --shadow-hover: 0 4px 10px rgba(18,19,15,0.06), 0 24px 48px -18px rgba(184,92,40,0.28);

  background: var(--bg);
  color: var(--ink);
  font-family: "Outfit", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  padding: 4.5rem 2.5rem 5rem;
}

.co * { box-sizing: border-box; }

.co__container {
  width: 70%;
  max-width: 70%;
  margin: 0;
  align-items: start;
}

.co__eyebrow {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-family: "Space Mono", monospace;
  font-size: 0.65rem;
  font-weight: 400;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--accent);
  margin-bottom: 1.1rem;
}

.co__eyebrow::before {
  content: "";
  width: 2.2rem;
  height: 1px;
  background: var(--accent);
  display: inline-block;
}

.co__title {
  font-family: "Playfair Display", Georgia, serif;
  font-size: 34px;
  line-height: 1.15;
  font-weight: 500;
  margin: 0 0 8px;
}

.co__title em {
  font-style: italic;
  color: var(--accent);
}

.co__subtitle {
  color: var(--muted);
  font-size: 15px;
  line-height: 1.6;
  max-width: 640px;
  margin: 0 0 32px;
}

.co__selection-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--dark);
  color: #f1ede2;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 18px;
}

.co__selection-badge-n {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: var(--accent);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
}

.course-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.course-list__header {
  display: grid;
  grid-template-columns: 72px 1fr;
  background: var(--dark);
  border-bottom: 2px solid var(--accent);
}

.course-list__header span:first-child {
  padding: 14px 16px;
  border-right: 1px solid rgba(255, 255, 255, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
}

.course-list__header span:nth-child(2) {
  padding: 14px 20px;
  display: flex;
  align-items: center;
}

.course-list__header span:last-child {
  display: none;
}

.course-list__header span {
  font-family: "Space Mono", monospace;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #d9d5c9;
}

.course-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* "Add" cell and "Course & fee" cell are now two fully separate boxes
   (own border + own background + own shadow) sitting side by side with a
   visible gap between them — not one shared box with an internal divider
   line. */
.course-row__head {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.course-row__check-cell {
  flex: 0 0 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
  padding: 10px 8px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.course-row__check-cell .co-checkbox {
  margin: 0;
}

.course-row__content-cell {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
  padding: 8px 23px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.course-row.is-open .course-row__check-cell,
.course-row.is-open .course-row__content-cell {
  border-color: color-mix(in oklab, var(--accent) 35%, var(--border));
  box-shadow: 0 18px 44px -28px rgba(18,19,15,.45);
}

.course-row.is-selected .course-row__content-cell {
  border-left: 3px solid var(--accent);
}

.course-row__body {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
}

.co-checkbox {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 1.5px solid #c9c3b4;
  border-radius: 5px;
  cursor: pointer;
  accent-color: var(--accent);
}

.co-checkbox:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.co-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--accent-soft);
  color: var(--accent-dark);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.25s ease, color 0.25s ease;
}

.co-icon svg {
  width: 19px;
  height: 19px;
}

.course-row.is-open .co-icon,
.course-row.is-selected .co-icon {
  background: var(--accent-dark);
  color: #fff;
}

.course-row__main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: left;
  font: inherit;
}

.course-row__name {
  font-size: 15.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink);
}

.course-row__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--muted);
}

.course-row__price {
  color: var(--accent-dark);
}

.course-row__count {
  position: relative;
  padding-left: 14px;
}

.course-row__count::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--border);
}

.co-toggle {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid var(--border);
  color: var(--muted);
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease, background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.co-toggle svg {
  width: 14px;
  height: 14px;
}

.co-toggle:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.co-toggle.is-open {
  transform: rotate(135deg);
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.course-row__body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: coFade 0.2s ease;
}

@keyframes coFade {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ── Program block (Program structure / Course Objectives / Services)
   category-header + 2-column checkmark card-grid — same visual system
   as the Course Structure section on the Architecture / Interior
   Designer pages. ── */
.pb-groups {
  display: flex;
  flex-direction: column;
}

.pb-cat-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.pb-cat-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  background: var(--accent-soft);
  color: var(--accent-dark);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pb-cat-icon svg {
  width: 14px;
  height: 14px;
}

.pb-cat-title {
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--accent-dark);
  white-space: nowrap;
}

.pb-cat-line {
  flex: 1;
  height: 1px;
  background: var(--border);
}

.pb-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 20px;
}

.pb-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid var(--border);
}

.pb-card-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 1px;
  border-radius: 7px;
  background: var(--accent-soft);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pb-card-icon svg {
  width: 12px;
  height: 12px;
  display: block;
}

.pb-card-text {
  font-size: 13.5px;
  line-height: 1.55;
  color: #3c3a35;
}

.pb-card.sub {
  grid-column: 1 / -1;
  padding-left: 4px;
}

@media (max-width: 640px) {
  .pb-grid {
    grid-template-columns: 1fr;
  }
}

.software-panel {
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.software-banner {
  background: var(--dark);
  color: #fff;
  padding: 12px 18px;
  font-size: 13.5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.software-banner__count {
  font-size: 11.5px;
  font-weight: 700;
  color: #d9d5c9;
  background: rgba(255, 255, 255, 0.1);
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

/* ── Grouped software picker (category headers + tool cards), same
   visual language as the Interior Designer page's software module.
   Each card keeps the checkbox in its own column, separate from the
   icon chip, so the two never sit on top of each other. ── */
.sw-groups {
  display: flex;
  flex-direction: column;
  gap: 22px;
  background: #fbf9f5;
  padding: 18px;
}

.sw-cat-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.sw-cat-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  background: var(--accent-soft);
  color: var(--accent-dark);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sw-cat-icon svg {
  width: 15px;
  height: 15px;
}

.sw-cat-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ink);
  white-space: nowrap;
}

.sw-cat-line {
  flex: 1;
  height: 1px;
  background: var(--border);
}

.sw-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.sw-card {
  display: grid;
  grid-template-columns: 22px 40px 1fr auto;
  align-items: center;
  column-gap: 12px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, background 0.15s ease;
}

.sw-card.sw-card--noselect {
  grid-template-columns: 40px 1fr;
  cursor: pointer;
}

@media (max-width: 560px) {
  .sw-card.sw-card--noselect {
    grid-template-columns: 30px 1fr;
  }
}

.sw-card:hover {
  box-shadow: var(--shadow-hover);
}

.sw-card.is-selected {
  border-color: var(--accent);
  background: #fbf3ea;
}

.sw-card.is-disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

/* Checkbox column — kept separate from the icon column below so they
   never overlap. */
.sw-card-check {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sw-card-check .co-checkbox {
  margin: 0;
}

.sw-card-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sw-card-icon svg {
  width: 17px;
  height: 17px;
}

.sw-card-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.sw-card-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--ink);
  line-height: 1.3;
}

.sw-card-sub {
  font-size: 11.5px;
  color: var(--muted);
  font-weight: 400;
  white-space: pre-line;
}

.sw-card-price {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--accent-dark);
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .sw-grid { grid-template-columns: 1fr; }
}

@media (max-width: 560px) {
  .sw-card { grid-template-columns: 18px 34px 1fr auto; column-gap: 8px; padding: 10px 12px; }
  .sw-card-icon { width: 30px; height: 30px; }
  .sw-card-icon svg { width: 14px; height: 14px; }
}

.course-list__total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #efe9dc;
  padding: 18px 24px;
  border: 1px solid var(--border);
}

/* The total row reuses .course-row__main for its layout, but that class
   defaults to flex-direction: column (stacking label + amount vertically,
   which read as "TOTAL AMOUNT" on one line and the number below it). For
   the total row specifically we want the label and the amount side by
   side on the same line, so this override switches it back to a row. */
.course-list__total .course-row__main--total {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.course-list__total .co-total-label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink);
}

.course-list__total .co-total-amount {
  font-size: 17px;
  font-weight: 800;
  color: var(--accent-dark);
  text-align: right;
}

.co__cta-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.btn-primary {
  background: var(--accent);
  color: #fff;
  border: none;
  padding: 14px 30px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.btn-primary:hover {
  background: var(--accent-dark);
  transform: translateY(-1px);
}

@media (max-width: 640px) {
  .co__title { font-size: 26px; }
}

@media (max-width: 768px) {

  .co{
    padding-top: 40px;
    padding-bottom: 90px;
    overflow-x:hidden;
  }

  .co__container{
    width:100%;
    max-width:100%;
    margin:0;
  }

  .co__title{
    font-size:26px;
    line-height:1.25;
  }

  .co__subtitle{
    max-width:100%;
    font-size:14px;
  }

  .co__selection-badge{
    display: flex;
    width: 100%;
    box-sizing: border-box;
    font-size: 12.5px;
  }

  .course-list__header{
    grid-template-columns: 56px 1fr;
  }

  .course-list__header span:first-child{
    padding: 12px 8px;
  }

  .course-list__header span:nth-child(2){
    padding: 12px 14px;
  }

  .course-row__head{
    gap: 8px;
  }

  .course-row__check-cell{
    flex-basis: 56px;
    padding: 14px 6px;
  }

  .course-row__content-cell{
    padding: 5px 14px;
    gap: 8px;
  }

  .co-icon{
    width: 34px;
    height: 34px;
    border-radius: 8px;
  }

  .co-icon svg{
    width: 16px;
    height: 16px;
  }

  .co-toggle{
    width:28px;
    height:28px;
  }

  .co-toggle svg{
    width:12px;
    height:12px;
  }

  .co-checkbox{
    width:18px;
    height:18px;
  }

  .course-row__name{
    font-size:14.5px;
    line-height:1.4;
  }

  .course-row__meta{
    font-size:10.5px;
    gap: 8px;
  }

  .course-row.is-selected .course-row__content-cell{
    border-left-width: 3px;
  }

  .course-row__body{
    padding: 14px;
    gap: 10px;
  }

  .pb-card-text{
    font-size: 13px;
  }

  .pb-cat-title{
    font-size: 11.5px;
  }

  .software-banner{
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding:10px 12px;
    font-size:12px;
  }

  .software-banner__count{
    font-size:10px;
  }

  .sw-groups{
    padding: 10px;
    gap: 16px;
  }

  .sw-cat-title{
    font-size: 12px;
  }

  .sw-card{
    grid-template-columns:16px 30px 1fr auto;
    column-gap:6px;
    padding:10px;
  }

  .sw-card-icon{
    width: 28px;
    height: 28px;
  }

  .sw-card-icon svg{
    width: 13px;
    height: 13px;
  }

  .sw-card-title{
    font-size:12px;
    line-height:1.4;
    word-break:break-word;
  }

  .sw-card-sub{
    font-size:10px;
  }

  .sw-card-price{
    font-size:10px;
  }

  .course-list__total{
    padding:14px 16px;
  }

  .co__cta-row{
    justify-content:center;
  }

  .btn-primary{
    width:100%;
  }

  .co-mobile-bar{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 300;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: var(--dark);
    color: #fff;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    box-shadow: 0 -8px 24px rgba(0,0,0,0.18);
  }

  .co-mobile-bar__info{
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .co-mobile-bar__count{
    font-size: 11.5px;
    font-weight: 600;
    color: #d9d5c9;
    white-space: nowrap;
  }

  .co-mobile-bar__amount{
    font-size: 16px;
    font-weight: 800;
    color: #fff;
  }

  .co-mobile-bar .btn-primary{
    width: auto;
    flex-shrink: 0;
    padding: 12px 22px;
  }

}

@media (min-width: 769px) {
  .co-mobile-bar{
    display: none;
  }
}

@media (max-width: 700px) {
  .co {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 1600px) {
  .co__container {
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
  }
}

.sw-card-row {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.sw-card-check-cell {
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow);
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.sw-card-check-cell .co-checkbox {
  margin: 0;
}

.sw-card-content-cell {
  flex: 1;
  display: grid;
  grid-template-columns: 40px 1fr auto;
  align-items: center;
  column-gap: 12px;
  min-width: 0;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 5px 10px;
  cursor: pointer;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, background 0.15s ease;
}

.sw-card-row.is-selected .sw-card-check-cell,
.sw-card-row.is-selected .sw-card-content-cell {
  border-color: var(--accent);
}

.sw-card-row.is-selected .sw-card-content-cell {
  background: #fbf3ea;
}

.sw-card-row:hover .sw-card-content-cell {
  box-shadow: var(--shadow-hover);
}

.sw-card-row.is-disabled .sw-card-check-cell,
.sw-card-row.is-disabled .sw-card-content-cell {
  cursor: not-allowed;
  opacity: 0.55;
}

@media (max-width: 560px) {
  .sw-card-row {
    gap: 6px;
  }
  .sw-card-check-cell {
    flex-basis: 34px;
  }
  .sw-card-content-cell {
    grid-template-columns: 30px 1fr auto;
    column-gap: 8px;
    padding: 4px 8px;
  }
}


`;

/* ----------------------------------------------------------------------
   Course Overview — main component
   ---------------------------------------------------------------------- */

function CourseOverview({ onApply, onTotalChange }) {
  const [openKey, setOpenKey] = useState("careerCounselling");
  const [selected, setSelected] = useState({});
  const [selectedSoftware, setSelectedSoftware] = useState({});
  const [selectedAiSoftware, setSelectedAiSoftware] = useState({});

  const toggleOpen = (key) => setOpenKey((prev) => (prev === key ? null : key));

  const toggleSelected = (key) =>
    setSelected((prev) => ({ ...prev, [key]: !prev[key] }));

  const softwareCount = Object.values(selectedSoftware).filter(Boolean).length;
  const aiSoftwareCount = Object.values(selectedAiSoftware).filter(Boolean).length;

  const toggleSoftware = (id) => {
    setSelectedSoftware((prev) => {
      const isSelected = !!prev[id];
      if (!isSelected && softwareCount >= MAX_SOFTWARE_PICKS) return prev;
      return { ...prev, [id]: !isSelected };
    });
  };

  const toggleAiSoftware = (id) => {
    setSelectedAiSoftware((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const softwareSubtotal = SOFTWARES.reduce(
    (sum, sw) => sum + (selectedSoftware[sw.id] ? sw.price : 0),
    0
  );

  // The flat 59,999 package price only kicks in once all 5 slots are used
  // (that's the deal: "any 5 softwares at just 59,999"). Before that, the
  // fee simply adds up the individually selected softwares.
  const softwareAmount =
    softwareCount === 0
      ? 0
      : softwareCount >= MAX_SOFTWARE_PICKS
      ? SOFTWARE_PACKAGE_PRICE
      : softwareSubtotal;

  const courseFeeTotal = COURSES.reduce(
    (sum, c) => sum + (selected[c.key] ? c.price : 0),
    0
  );

  const total = courseFeeTotal + softwareAmount;

  const moduleCount =
    Object.values(selected).filter(Boolean).length + (softwareCount > 0 ? 1 : 0);

  // Course-only and software-only name lists, kept SEPARATE so the parent
  // page / backend payload never mixes the two up.
  const selectedCourseNames = COURSES.filter((c) => selected[c.key]).map((c) => c.name);
  const selectedSoftwareNames = SOFTWARES.filter((sw) => selectedSoftware[sw.id]).map(
    (sw) => sw.name
  );

  // Flat, human-readable list of everything currently selected — used for
  // display (badges, the "X modules selected" text) and for the summary.
  const selectedNames = [
    ...selectedCourseNames,
    ...(softwareCount > 0
      ? [`Advance Architecture Softwares (${selectedSoftwareNames.join(", ")})`]
      : []),
  ];

  // Lets the parent page (CustomizeYourProgramPage) reuse this total, so
  // the fee shown in an admissions/summary section stays in sync, AND lets
  // it store courses vs software (and their fees) separately for the
  // backend payload.
  useEffect(() => {
    if (onTotalChange) {
      onTotalChange(total, moduleCount, selectedNames, {
        courseNames: selectedCourseNames,
        softwareNames: selectedSoftwareNames,
        courseFee: courseFeeTotal,
        softwareFee: softwareAmount,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    total,
    moduleCount,
    selectedNames.join("|"),
    selectedCourseNames.join("|"),
    selectedSoftwareNames.join("|"),
    courseFeeTotal,
    softwareAmount,
  ]);

  const renderCourseRow = (course) => {
    const isOpen = openKey === course.key;
    const isSelected = !!selected[course.key];
    const topicCount = course.blocks.reduce((n, b) => n + b.items.length, 0);
    return (
      <div
        className={`course-row${isSelected ? " is-selected" : ""}${isOpen ? " is-open" : ""}`}
        key={course.key}
      >
        <div className="course-row__head">
          <span className="course-row__check-cell">
            <input
              type="checkbox"
              className="co-checkbox"
              checked={isSelected}
              onChange={() => toggleSelected(course.key)}
              aria-label={`Add ${course.name}`}
            />
          </span>
          <span className="course-row__content-cell">
            <span className="co-icon" aria-hidden="true">
              <CoModuleIcon type={course.icon} />
            </span>
            <button
              type="button"
              className="course-row__main"
              onClick={() => toggleOpen(course.key)}
            >
              <p className="course-row__name">{course.name}</p>
              <span className="course-row__meta">
                <span className="course-row__price">{fmtINR(course.price)}</span>
                <span className="course-row__count">{topicCount} topics</span>
              </span>
            </button>
            <button
              type="button"
              className={`co-toggle ${isOpen ? "is-open" : ""}`}
              onClick={() => toggleOpen(course.key)}
              aria-label={isOpen ? "Collapse details" : "Expand details"}
            >
              <CoToggleIcon />
            </button>
          </span>
        </div>

        {isOpen && (
          <div className="course-row__body">
            {course.blocks.map((block, i) => (
              <ProgramBlock block={block} key={i} />
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderSoftwareRow = () => {
    const isOpen = openKey === "advanceArchitectureSoftwares";
    const isSelected = softwareCount > 0;
    return (
      <div
        className={`course-row${isSelected ? " is-selected" : ""}${isOpen ? " is-open" : ""}`}
        key="advanceArchitectureSoftwares"
      >
        <div className="course-row__head">
          <span className="course-row__check-cell">
            <input
              type="checkbox"
              className="co-checkbox"
              checked={isSelected}
              readOnly
              onClick={() => toggleOpen("advanceArchitectureSoftwares")}
              aria-label="Advance Architecture Softwares"
            />
          </span>
          <span className="course-row__content-cell">
            <span className="co-icon" aria-hidden="true">
              <CoModuleIcon type="cube" />
            </span>
            <button
              type="button"
              className="course-row__main"
              onClick={() => toggleOpen("advanceArchitectureSoftwares")}
            >
              <p className="course-row__name">Advance Architecture Softwares</p>
              <span className="course-row__meta">
                <span className="course-row__price">
                  {isSelected ? fmtINR(softwareAmount) : "Select up to 5"}
                </span>
                <span className="course-row__count">{SOFTWARES.length} options</span>
              </span>
            </button>
            <button
              type="button"
              className={`co-toggle ${isOpen ? "is-open" : ""}`}
              onClick={() => toggleOpen("advanceArchitectureSoftwares")}
              aria-label={isOpen ? "Collapse software list" : "Expand software list"}
            >
              <CoToggleIcon />
            </button>
          </span>
        </div>

        {isOpen && (
          <div className="course-row__body course-row__body--software">
            <div className="software-panel">
              <div className="software-banner">
                <span>Select any 5 Softwares at just 59,999 INR</span>
                <span className="software-banner__count">
                  {softwareCount}/{MAX_SOFTWARE_PICKS} selected
                </span>
              </div>
              <div className="sw-groups">
                {SOFTWARE_GROUPS.map((group) => (
                  <div className="sw-category" key={group.category}>
                    <div className="sw-cat-header">
                      <span className="sw-cat-icon" aria-hidden="true">
                        <SwCategoryIcon type={group.icon} />
                      </span>
                      <span className="sw-cat-title">{group.category}</span>
                      {/* <span className="sw-cat-line" /> */}
                    </div>
                    <div className="sw-grid">

                      {/* {group.ids.map((id) => {
                        const sw = SOFTWARES.find((s) => s.id === id);
                        if (!sw) return null;
                        const isSwSelected = !!selectedSoftware[sw.id];
                        const atLimit = softwareCount >= MAX_SOFTWARE_PICKS && !isSwSelected;
                        const theme = SW_ICON_THEME[sw.icon] ?? SW_ICON_THEME.autocad;
                        return (
                          <label
                            className={`sw-card${isSwSelected ? " is-selected" : ""}${atLimit ? " is-disabled" : ""}`}
                            key={sw.id}
                          >
                           
                            <span className="sw-card-check">
                              <input
                                type="checkbox"
                                className="co-checkbox"
                                checked={isSwSelected}
                                disabled={atLimit}
                                onChange={() => toggleSoftware(sw.id)}
                                aria-label={`Add ${sw.name}`}
                              />
                            </span>
                            <span className="sw-card-icon" style={{ background: theme.bg, color: theme.fg }}>
                              <SwToolIcon type={sw.icon} />
                            </span>
                            <span className="sw-card-text">
                              <span className="sw-card-title">{sw.name}</span>
                              {sw.subtitle && <span className="sw-card-sub">{sw.subtitle}</span>}
                            </span>
                            <span className="sw-card-price">{fmtINR(sw.price)}</span>
                          </label>
                        );
                      })} */}

{group.ids.map((id) => {
  const sw = SOFTWARES.find((s) => s.id === id);
  if (!sw) return null;
  const isSwSelected = !!selectedSoftware[sw.id];
  const atLimit = softwareCount >= MAX_SOFTWARE_PICKS && !isSwSelected;
  const theme = SW_ICON_THEME[sw.icon] ?? SW_ICON_THEME.autocad;
  return (
    <div
      className={`sw-card-row${isSwSelected ? " is-selected" : ""}${atLimit ? " is-disabled" : ""}`}
      key={sw.id}
    >
      <span className="sw-card-check-cell">
        <input
          type="checkbox"
          className="co-checkbox"
          checked={isSwSelected}
          disabled={atLimit}
          onChange={() => toggleSoftware(sw.id)}
          aria-label={`Add ${sw.name}`}
        />
      </span>
      <div
        className="sw-card-content-cell"
        role="button"
        tabIndex={atLimit ? -1 : 0}
        onClick={() => !atLimit && toggleSoftware(sw.id)}
        onKeyDown={(e) => {
          if (!atLimit && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            toggleSoftware(sw.id);
          }
        }}
      >
        <span className="sw-card-icon" style={{ background: theme.bg, color: theme.fg }}>
          <SwToolIcon type={sw.icon} />
        </span>
        <span className="sw-card-text">
          <span className="sw-card-title">{sw.name}</span>
          {sw.subtitle && <span className="sw-card-sub">{sw.subtitle}</span>}
        </span>
        <span className="sw-card-price">{fmtINR(sw.price)}</span>
      </div>
    </div>
  );
})}

                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

const renderAiSoftwareRow = () => {
  const isOpen = openKey === "aiRender";
  const isSelected = !!selected["aiRender"] || aiSoftwareCount > 0;
  return (
    <div
      className={`course-row${isSelected ? " is-selected" : ""}${isOpen ? " is-open" : ""}`}
      key="aiRender"
    >
      <div className="course-row__head">
        <span className="course-row__check-cell">
          <input
            type="checkbox"
            className="co-checkbox"
            checked={isSelected}
            onChange={() => toggleSelected("aiRender")}
            aria-label="Architecture AI Software"
          />
        </span>
        <span className="course-row__content-cell">
          <span className="co-icon" aria-hidden="true">
            <CoModuleIcon type="spark" />
          </span>
          <button
            type="button"
            className="course-row__main"
            onClick={() => toggleOpen("aiRender")}
          >
            <p className="course-row__name">Architecture AI Software</p>
            <span className="course-row__meta">
              <span className="course-row__price">{fmtINR(14999)}</span>
              <span className="course-row__count">{AI_SOFTWARES.length} tools</span>
            </span>
          </button>
          <button
            type="button"
            className={`co-toggle ${isOpen ? "is-open" : ""}`}
            onClick={() => toggleOpen("aiRender")}
            aria-label={isOpen ? "Collapse AI software list" : "Expand AI software list"}
          >
            <CoToggleIcon />
          </button>
        </span>
      </div>

      {isOpen && (
        <div className="course-row__body course-row__body--software">
          <div className="software-panel">
            {/* banner (background + "X selected") removed */}
            <div className="sw-groups">
              <div className="sw-grid">
                {AI_SOFTWARES.map((sw) => {
                  const isSwSelected = !!selectedAiSoftware[sw.id];
                  const theme = SW_ICON_THEME[sw.icon] ?? SW_ICON_THEME.autocad;
                  return (
                    <div
                      role="button"
                      tabIndex={0}
                      className={`sw-card sw-card--noselect${isSwSelected ? " is-selected" : ""}`}
                      key={sw.id}
                      onClick={() => toggleAiSoftware(sw.id)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggleAiSoftware(sw.id);
                        }
                      }}
                    >
                      <span className="sw-card-icon" style={{ background: theme.bg, color: theme.fg }}>
                        <SwToolIcon type={sw.icon} />
                      </span>
                      <span className="sw-card-text">
                        <span className="sw-card-title">{sw.name}</span>
                        {sw.subtitle && <span className="sw-card-sub">{sw.subtitle}</span>}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

  return (
    <section className="co">
      <style>{COURSE_OVERVIEW_CSS}</style>

      <div className="co__container">
        <div className="co__eyebrow">Build your own path</div>
        <h2 className="co__title">
          Customize <em>Your Program</em>
        </h2>
        <p className="co__subtitle">
          Select only the modules you need. Add career counselling, software
          training, construction technology, or placement assistance
          individually — your fee updates as you build.
        </p>

        {moduleCount > 0 && (
          <div className="co__selection-badge">
            <span className="co__selection-badge-n">{moduleCount}</span>
            module{moduleCount !== 1 ? "s" : ""} selected · {fmtINR(total)}
          </div>
        )}

        <div className="course-list">
          <div className="course-list__header">
            <span>Add</span>
            <span>Course &amp; fee</span>
            <span></span>
          </div>

          {renderCourseRow(COURSES[0])}
          {renderCourseRow(COURSES[1])}
          {renderCourseRow(COURSES[2])}
          {renderSoftwareRow()}
          {renderAiSoftwareRow()}
          {renderCourseRow(COURSES[4])}
          {renderCourseRow(COURSES[5])}
          {renderCourseRow(COURSES[6])}

          <div className="course-list__total">
            <span></span>
            <div className="course-row__main course-row__main--total">
              <span className="co-total-label">Total amount</span>
              <span className="co-total-amount">{fmtINR(total)}</span>
            </div>
            <span></span>
          </div>
        </div>

        <div className="co__cta-row">
          <button
            className="btn-primary"
            onClick={() => (onApply ? onApply() : alert("Start Application clicked"))}
          >
            Start Application
          </button>
        </div>
      </div>

      {moduleCount > 0 && (
        <div className="co-mobile-bar">
          <div className="co-mobile-bar__info">
            <span className="co-mobile-bar__count">
              {moduleCount} module{moduleCount !== 1 ? "s" : ""} selected
            </span>
            <span className="co-mobile-bar__amount">{fmtINR(total)}</span>
          </div>
          <button
            type="button"
            className="btn-primary"
            onClick={() => (onApply ? onApply() : alert("Start Application clicked"))}
          >
            Apply
          </button>
        </div>
      )}
    </section>
  );
}

/* ==========================================================================
   ==================  END OF MERGED COURSE OVERVIEW  =======================
   ========================================================================== */

const customizeTabs = [
  ["overview", "Overview"],
  ["instructors", "Instructors"],
  ["outcome", "Outcome"],
  ["admissions", "Admissions"],
  ["enroll", "Enroll"],
];

const VALID_TABS = customizeTabs.map(([id]) => id);

function getTabFromHash() {
  if (typeof window === "undefined") {
    return "overview";
  }

  const hash = window.location.hash.replace("#", "");
  return VALID_TABS.includes(hash) ? hash : "overview";
}

// Country codes for the mobile-number field. Add/remove entries here — the
// dropdown in CustomizeAdmissionForm renders from this list, so it stays dynamic.

const countryCodes = [
  { code: "+91", label: "IN +91", minLength: 10, maxLength: 10 },
  { code: "+1", label: "US +1", minLength: 10, maxLength: 10 },
  { code: "+44", label: "UK +44", minLength: 10, maxLength: 10 },
  { code: "+61", label: "AU +61", minLength: 9, maxLength: 9 },
  { code: "+971", label: "AE +971", minLength: 9, maxLength: 9 },
  { code: "+65", label: "SG +65", minLength: 8, maxLength: 8 },
  { code: "+974", label: "QA +974", minLength: 8, maxLength: 8 },
  { code: "+966", label: "SA +966", minLength: 9, maxLength: 9 },
  { code: "+27", label: "ZA +27", minLength: 9, maxLength: 9 },
  { code: "+49", label: "DE +49", minLength: 11, maxLength: 11 },
];

const highlights = [
  {
    title: "National and International Expert Trainers",
    alwaysOpen: true,
    detail: (
      <div>
        <p style={{ marginBottom: "1.2rem", color: "var(--stone)", fontSize: "0.85rem", fontWeight: 300, lineHeight: 1.7 }}>
          Learn from the experts in their fields with peronalised guidance
        </p>
        <div className="hl-stat-grid" style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "1.5px",
          background: "var(--sand)",
          marginBottom: 0,
        }}>
          <div className="hl-stat-cell" style={{
            display: "flex",
            alignItems: "center",
            gap: "1.3rem",
            background: "var(--charcoal)",
            padding: "1.8rem 2rem",
            minHeight: "90px",
          }}>
            <div style={{ color: "var(--terra-lt)", fontFamily: "var(--serif)", fontSize: "2.6rem", lineHeight: 1, flexShrink: 0 }}>2</div>
            <div style={{ minWidth: 0 }}>
              <div className="hl-stat-label" style={{ color: "var(--cream)", fontSize: "0.85rem", fontWeight: 600, whiteSpace: "nowrap" }}>International Guest faculties</div>
            </div>
          </div>
          <div className="hl-stat-cell" style={{
            display: "flex",
            alignItems: "center",
            gap: "1.3rem",
            background: "var(--charcoal)",
            padding: "1.8rem 2rem",
            minHeight: "90px",
          }}>
            <div style={{ color: "var(--terra-lt)", fontFamily: "var(--serif)", fontSize: "2.6rem", lineHeight: 1, flexShrink: 0 }}>8</div>
            <div style={{ minWidth: 0 }}>
              <div className="hl-stat-label" style={{ color: "var(--cream)", fontSize: "0.85rem", fontWeight: 600, whiteSpace: "nowrap" }}>Industry Professionals</div>
            </div>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Max 20 Students per batch",
    detail: (
      <div>
        <p style={{ color: "var(--stone)", fontSize: "0.85rem", fontWeight: 300, lineHeight: 1.7 }}>
          Small batch sizes mean every student gets direct, personalised feedback from trainers — not lost in a crowd of hundreds.
        </p>
      </div>
    ),
  },
  {
    title: "AI-Powered Architecture Tools",
    detail: (
      <div>
        <p style={{ color: "var(--stone)", fontSize: "0.85rem", fontWeight: 300, lineHeight: 1.7 }}>
          Hands-on training across AutoCAD, Revit/BIM, SketchUp, and AI-driven design & visualization tools. AI is reshaping how buildings are designed, documented, and delivered — this program makes sure you adopt that technology early instead of catching up to it later.
        </p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "1.6rem", marginTop: "1.2rem", marginBottom: "1.4rem" }}>
          {[
            { name: "Revit", src: "/assets/img/revit-logo.png" },
            { name: "Grasshoper", src: "/assets/img/Grasshoper.png" },
            { name: "Autocad", src: "/assets/img/autocad.png" },
            // { name: "Vector works", src: "/assets/img/vectorworks.png" },
            { name: "Rhino", src: "/assets/img/Rhino.png" },
          ].map((sw) => (
            <div key={sw.name} style={{ textAlign: "center", width: "80px" }}>
              <img src={sw.src} alt={sw.name} style={{ maxWidth: "80px", marginBottom: "0.4rem" }} />
              <div style={{ color: "var(--stone)", fontSize: "0.72rem", fontWeight: 500 }}>{sw.name}</div>
            </div>
          ))}
        </div>
      </div>
    ),
  },
  {
    title: "350 Hours Live Sessions",
    detail: "Real-time, instructor-led classes — not pre-recorded videos. Ask questions, get reviewed live, and learn alongside your batch.",
  },
  {
    title: "Customized Program for Each Candidate",
    detail: "Your learning path is shaped around your existing strengths and the gaps you want to close — not a one-size-fits-all syllabus.",
  },
];



const HL_OPEN_HEIGHTS = { 0: 280, 1: 200, 2: 480 };

const admissionItems = [
  "Career Counselling and Guidance",
  "Soft Skills Development",
  "Architecture Drawings and Services Standards",
  "Advance Architecture Softwares",
  "Advance Construction Technologies and Materials",
  "NBC and Liasoning",
  "Placement assistance",
];

const growthCards = [
  {
    title: " Project Execution Confidence",
    text: "Develop the confidence to independently manage architectural projects from concept to completion.",
    icon: (<svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>),
  },
  {
    title: " Real Industry Exposure",
    text: "Learn how architecture firms actually work through practical workflows, live projects, and expert mentoring.",
    icon: (<svg viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /></svg>),
  },
  {
    title: "Future-Ready Skills",
    text: "Stay ahead with AI-powered workflows, industry tools, and evolving technologies shaping the future of architecture.",
    icon: (<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></svg>),
  },
  {
    title: "Professional Growth",
    text: "Strengthen your communication, leadership, presentation, and client management skills to grow as a professional.",
    icon: (<svg viewBox="0 0 24 24"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>),
  },
  {
    title: "Self Evaluate",
    text: "Make sharper, better-informed career decisions for the long term.",
    icon: (<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4" /><path d="M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2" /><path d="M12 12v6" /></svg>),
  },
  {
    title: "Professional Network",
    text: "Build a strong, lasting network of peers, alumni and IPDI mentors.",
    icon: (<svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>),
  },
];


const outcomeCards = [
  "Critical thinking skills",
  "Practical Approach toward design",
  "Professional Skills",
  "Communication skills",
  "Broader Vision",
  "The ability to execute your own ideas",
  "Ability to coordinate multidisciplinary teams",
  "Build Confidence",
];

// Kept exported as-is: Programs.jsx (and possibly other pages) still read
// customizeBundles.length / fee data from here for their own summary cards.
// The actual "Customize Program" tab UI now lives in <CourseOverview />.
export const customizeBundles = [
  {
    title: "Career Counselling and Guidance",
    fee: "4,999 INR",
    sections: [
      "Program structure",
      "Career Counselling",
      "Career Guidance",
      "Course Objectives",
      "Make the candidates know their own self",
      "Enhance their inner core strengths, minimize weaknesses, and identify interests",
      "Guidance for choosing the correct path in career",
      "Direction to use the acquired strength in the right direction",
      "Prevent one from work-related stress",
    ],
  },
  {
    title: "Soft Skills Development",
    fee: "9,999 INR",
    sections: [
      "Program structure",
      "Improve Communication and Self-Marketing skills",
      "Enhance Interactive Skills",
      "Build a Positive Competitive attitude",
      "Induce right Work Ethics",
      "Build Human Relations",
      "Learn Time Management",
    ],
  },
  {
    title: "Architecture Drawings and Services Standards",
    fee: "19,999 INR",
    sections: [
      "Program structure",
      "Auto CAD Drafting Standards",
      "Introduction to Types of Drawing for building execution",
      "Working Drawings standards",
      "Folder Management",
      "Virtual Tour for explaining On-site execution",
      "Course Objectives",
      "Renewed confidence in your technical drawing skills.",
      "To learn technical drawings as per industry standards.",
      "To understand onsite execution problems and their solution",
      "Services",
      "In-depth understanding of Building Services and their varied functions",
      "A. Electrical",
      "B. Mechanical",
      "C. Plumbing",
      "Basic consideration of services and how to implement them in their design",
      "Preparing service drawings",
      "On-site and off-site Consultant coordination.",
      "Course Objectives",
      "To understand services and learn to produce their drawings",
      "To understand various types of services and consultant teams' coordination",
      "To understand onsite execution problems and work out solutions",
    ],
  },
  {
    title: "Advance Architecture Softwares",
    fee: "Select any 5 Softwares at just 59,999 /- INR",
    sections: [
      "Building Information Modeling (BIM)",
     
       "A. Advance Revit Architecture",
       "B. Navisworks",
     
      "Auto-CAD (Drafting Standards)",
      "Rhinoceros",
      "Grasshopper",
      "Global Mapper",
      "V-Ray",
      "Sketchup",
      "ArcGIS",
      "Primavera",
      // "Adobe Photoshop",
      // "Adobe InDesign",
      "Adobe Illustrator",
    ],
  },
  {
    title: "Advance Construction Technologies and Materials",
    fee: "14,999 INR",
    sections: [
      "Introduction to Current Construction Technologies and Trends",
      "Introduction to Latest construction materials",
      "Role of materials in a building envelope",
      "A brief introduction to LEED certifications",
      "A brief overview of Sustainable building materials",
      "Course Objectives",
      "To develop knowledge about new construction techniques and materials",
      "To improve overall design skills",
      "To create an awareness of sustainable development in the industry",
      "To initiate the process of innovative thinking ability with the help of different materials and advanced technologies",
    ],
  },
  {
    title: "NBC and Liasoning",
    fee: "14,999 INR",
    sections: [
      "A brief introduction about NBC",
      "Fire norms",
      "Liasoning",
      "Building permission & required documents",
      "Development plan",
      "Regional plan",
      "List of documents required for sanction process",
      "Guidelines to read legal documents",
      "Know-hows of Sanction process",
      "Provide a brief understanding of Purpose and need of various documents",
      "Types of NOC",
      "Course Objectives",
      "Awareness of NBC (National Building Code) Standards",
      "Importance of National and International Building Codes in Architectural Practice",
      "To improve Design Skills",
      "Awareness of Building Bylaws",
      "Importance of Building Bylaws",
    ],
  },
  {
    title: "Placement assistance",
    fee: "1999 INR",
    sections: [
      "Program structure",
      "An Introduction about Live Project and its Management",
      "Interactions with Site-coordinators",
      "Involvement in Live Projects",
      "Working Drawings",
      "Coordination between various Consultants",
      "Service Layouts and Drawings",
      "Course Objectives",
      "To provide hands-on experience to the candidates",
      "To make the candidate technically sound",
      "To offer a real-time experience of how a project works",
      "To build Confidence to handle project and people on site from scratch to end",
      "To train candidates to work on a project single-handedly from start to end",
    ],
  },
];

function HeroIcon({ type }) {
  if (type === "duration") {
    return (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v6l4 2" />
      </svg>
    );
  }

  if (type === "classes") {
    return (
      <svg viewBox="0 0 24 24">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M8 21h8M12 17v4" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

const namePattern = /^[A-Za-z\s.'-]+$/;

function CustomizeAdmissionForm({
  sectionId,
  selectedCount,
  selectedFee,
  hasSelectedModules,
  onStartApplication,
  selectedModules = [],
  selectedBreakdown = { courseNames: [], softwareNames: [], courseFee: 0, softwareFee: 0 },
  reveal,
}) {
  const [countryCode, setCountryCode] = useState("+91");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    city: "",
    qualification: "",
  });

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

 const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "mobile") {
    const selectedCountry = countryCodes.find(
      (country) => country.code === countryCode
    );

    const maxLength = selectedCountry?.maxLength || 15;

    const mobileValue = value
      .replace(/\D/g, "")
      .slice(0, maxLength);

    setFormData((prev) => ({
      ...prev,
      mobile: mobileValue,
    }));

    if (errors.mobile) {
      setErrors((prev) => ({
        ...prev,
        mobile: "",
      }));
    }

    return;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (
    ["firstName", "lastName"].includes(name) &&
    value.trim() &&
    !namePattern.test(value)
  ) {
    setErrors((prev) => ({
      ...prev,
      [name]: "Name can contain letters only",
    }));
  } else if (errors[name]) {
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  }
};

  const validate = () => {
    const nextErrors = {};

if (!formData.firstName.trim()) nextErrors.firstName = "First name is required";
else if (!namePattern.test(formData.firstName.trim())) nextErrors.firstName = "Name can contain letters only";
if (!formData.lastName.trim()) nextErrors.lastName = "Last name is required";
else if (!namePattern.test(formData.lastName.trim())) nextErrors.lastName = "Name can contain letters only";

    if (!formData.email.trim()) {
      nextErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      nextErrors.email = "Enter a valid email address";
    }

   if (!formData.mobile.trim()) {
  nextErrors.mobile = "Mobile number is required";
} else {
  const selectedCountry = countryCodes.find(
    (country) => country.code === countryCode
  );

  const minLength = selectedCountry?.minLength || 8;
  const maxLength = selectedCountry?.maxLength || 15;

  const mobile = formData.mobile.trim();

  if (mobile.length < minLength || mobile.length > maxLength) {
    if (minLength === maxLength) {
      nextErrors.mobile = `Enter a valid ${minLength}-digit number`;
    } else {
      nextErrors.mobile = `Enter a valid mobile number (${minLength}-${maxLength} digits)`;
    }
  }
}

    if (!formData.city.trim()) nextErrors.city = "City is required";
    if (!formData.qualification) nextErrors.qualification = "Please select your qualification";

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      // Scroll/focus first invalid field into view for quicker fixing
      const firstErrorField = document.querySelector(".apply-field-error, .apply-select-error");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    const { courseNames, softwareNames, courseFee, softwareFee } = selectedBreakdown;

    const payload = {
      ...formData,
      mobileCode: countryCode,
      formName: "Customize Your Program",

      // Courses and software are now stored SEPARATELY — this was the bug:
      // both fields used to receive the same combined `selectedModules`
      // list (and were empty whenever selectedModules wasn't passed in at
      // all), so the backend never actually got the real selection.
      courses: courseNames.length > 0 ? courseNames.join(", ") : "",
      coursefees: courseFee > 0 ? `INR ${courseFee.toLocaleString()} /-` : "",

      software: softwareNames.length > 0 ? softwareNames.join(", ") : "",
      softfees: softwareFee > 0 ? `INR ${softwareFee.toLocaleString()} /-` : "",

      // Combined summary too, in case the backend/CRM wants one field with
      // everything the candidate picked.
      selectedModules: selectedModules.length > 0 ? selectedModules.join(", ") : "",
      totalFee: hasSelectedModules ? selectedFee : "",
    };

    setSubmitting(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/programCustom/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (res.ok) {
        setShowSuccess(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          city: "",
          qualification: "",
        });
        setErrors({});
      } else {
        setErrors({ form: typeof data === "string" ? data : "Something went wrong. Please try again." });
      }
    } catch (err) {
      console.error(err);
      setErrors({ form: "Server error. Please check your connection and try again." });
    } finally {
      setSubmitting(false);
    }
  };

  const rv = reveal ? " rv" : "";

  return (
    <section className={`fee-apply customize-admissions${rv}`} id={sectionId}>

      <style>{`
        /* Large/big PC monitor only — same breakpoint as the site-wide
            */
        @media (min-width: 1600px) {
          .architect-theme .fee-apply.customize-admissions {
            max-width: 100%;
            margin-left: 0;
            margin-right: 0;
          }
        }

        /* Inline validation + success popup styles */
        .apply-field-error,
        .apply-select-error {
          border-width: 1px !important;
          border-color: #ff4d4d !important;
          box-shadow: none;
        }
        .apply-error-text {
          color: #ff4d4d;
          font-size: 0.72rem;
          font-weight: 400;
          margin-top: 0.3rem;
          margin-bottom: 0.6rem;
        }
        .apply-form-error {
          color: #ff4d4d;
          font-size: 0.8rem;
          font-weight: 400;
          background: rgba(255, 77, 77, 0.08);
          border: 1px solid rgba(255, 77, 77, 0.3);
          border-radius: 6px;
          padding: 0.7rem 0.9rem;
          margin-bottom: 1rem;
        }

        .success-popup-overlay {
          position: fixed;
          inset: 0;
          background: rgba(28, 26, 23, 0.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 1rem;
          animation: successFadeIn 0.25s ease;
        }
        .success-popup-card {
          background: #fff;
          border-radius: 14px;
          max-width: 400px;
          width: 100%;
          padding: 2.6rem 2rem 2.2rem;
          text-align: center;
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
          animation: successPopIn 0.3s ease;
        }
        .success-popup-icon {
          width: 62px;
          height: 62px;
          border-radius: 50%;
          background: #1c1a17;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.3rem;
        }
        .success-popup-icon svg {
          width: 28px;
          height: 28px;
          stroke: #c84b20;
          fill: none;
          stroke-width: 2.5;
        }
        .success-popup-title {
          font-family: var(--serif);
          font-size: 1.4rem;
          color: #1c1a17;
          margin-bottom: 0.6rem;
        }
        .success-popup-text {
          font-size: 0.88rem;
          color: var(--stone, #7d766c);
          line-height: 1.6;
          margin-bottom: 1.8rem;
        }
        .success-popup-btn {
          background: #c84b20;
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 0.75rem 2rem;
          font-size: 0.85rem;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.2s ease;
        }
        .success-popup-btn:hover {
          background: #a83e1a;
        }
        @keyframes successFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes successPopIn {
          from { opacity: 0; transform: scale(0.92) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }


        .apply-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='9' viewBox='0 0 14 9' fill='none'><path d='M1 1l6 6 6-6' stroke='%23555' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px 8px;
  padding-right: 42px;
}


      `}</style>

      <div className="fee-box">
        <div className="fee-lbl">Program Fee</div>
        <div className="fee-amt">{hasSelectedModules ? selectedFee : "as per module"}</div>
        <div className="fee-period">
          {hasSelectedModules
            ? `${selectedCount} module${selectedCount !== 1 ? "s" : ""} selected`
            : "Recommended 15 hrs/week"}
        </div>
        <div className="fee-incl-t">What's Included</div>
        <div className="fee-list">
          {admissionItems.map((item) => (
            <div className="fee-row" key={item}>
              <CheckIcon />
              {item}
            </div>
          ))}
        </div>
        <div style={{ marginTop: "2.2rem", paddingTop: "1.6rem", borderTop: "1px solid rgba(255,255,255,0.12)" }}>
          <span style={{ color: "#fff", fontFamily: "var(--serif)", fontSize: "2rem", fontWeight: 300 }}>
            Total fee INR{" "}
            <span
              style={{
                color: "#fff",
                display: "inline-block",
                fontFamily: "inherit",
                fontSize: hasSelectedModules ? "2.8rem" : "2rem",
                fontWeight: 400,
                lineHeight: 1,
              }}
            >
              {hasSelectedModules ? selectedFee.replace("INR ", "") : "as per module"}
            </span>
          </span>
        </div>
      </div>
      {/* <div className="apply-box" id={sectionId === "admissions" ? "apply" : undefined}> */}
      <div className="apply-box" id={sectionId === "enroll" ? "apply" : undefined}>
        <div className="apply-eyebrow">Take the First Step</div>
        <div className="apply-title">I'm interested in this program</div>
        <div className="apply-sub" style={{ marginTop: 0 }}>Personal Information</div>

        {errors.form ? <div className="apply-form-error">{errors.form}</div> : null}

        <div className="apply-row">
          <div style={{ flex: 1 }}>
            <input
              className={`apply-field${errors.firstName ? " apply-field-error" : ""}`}
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First name *"
            />
            {errors.firstName ? <div className="apply-error-text">{errors.firstName}</div> : null}
          </div>
          <div style={{ flex: 1 }}>
            <input
              className={`apply-field${errors.lastName ? " apply-field-error" : ""}`}
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last name *"
            />
            {errors.lastName ? <div className="apply-error-text">{errors.lastName}</div> : null}
          </div>
        </div>

        <input
          className={`apply-field${errors.email ? " apply-field-error" : ""}`}
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email ID *"
          style={{ marginBottom: errors.email ? "0" : ".9rem" }}
        />
        {errors.email ? <div className="apply-error-text">{errors.email}</div> : null}

        <div className="apply-phone">
          <select
            className="apply-code-select"
            value={countryCode}
            onChange={(e) => setCountryCode(e.target.value)}
            aria-label="Country code"
          >
            {countryCodes.map((c) => (
              <option key={c.code} value={c.code}>
                {c.code}
              </option>
            ))}
          </select>

          <input
            className={`apply-field apply-field-phone${errors.mobile ? " apply-field-error" : ""}`}
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="Mobile no. *"
            inputMode="numeric"
            maxLength={
  countryCodes.find(
    (country) => country.code === countryCode
  )?.maxLength || 15
}
          />

         
        </div>
        {errors.mobile ? <div className="apply-error-text">{errors.mobile}</div> : null}

        <input
          className={`apply-field${errors.city ? " apply-field-error" : ""}`}
          name="city"
          value={formData.city}
          onChange={handleChange}
          type="text"
          placeholder="City *"
          style={{ marginTop: ".9rem" }}
        />
        {errors.city ? <div className="apply-error-text">{errors.city}</div> : null}

        <div className="apply-sub" style={{ fontSize: "0.8rem" }}>Qualification</div>
        <select
          className={`apply-select${errors.qualification ? " apply-select-error" : ""}`}
          name="qualification"
          value={formData.qualification}
          onChange={handleChange}
          style={{ fontSize: "0.95rem" }}
        >
         <option value="" disabled>Select degree</option>
            <option>Bachelor of Architecture</option>
            <option>Diploma in Architecture</option>
            <option>Pursuing B.Arch (Final Year)</option>
            <option>Other</option>
        </select>
        {errors.qualification ? <div className="apply-error-text">{errors.qualification}</div> : null}

        <button
          className="apply-btn"
          type="button"
          onClick={handleSubmit}
          disabled={submitting}
          style={{ fontSize: "0.85rem", opacity: submitting ? 0.7 : 1, cursor: submitting ? "not-allowed" : "pointer" }}
        >
          {submitting ? "Submitting..." : "Start Application"}
        </button>
      </div>

      {showSuccess ? (
        <div className="success-popup-overlay" onClick={() => setShowSuccess(false)}>
          <div className="success-popup-card" onClick={(e) => e.stopPropagation()}>
            <div className="success-popup-icon">
              <svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" /></svg>
            </div>
            <div className="success-popup-title">Application Submitted</div>
            <p className="success-popup-text">
              Thanks for applying to IPDI! Our admissions team will reach out to you shortly on the details you shared.
            </p>
            <button className="success-popup-btn" type="button" onClick={() => setShowSuccess(false)}>
              Done
            </button>
          </div>
        </div>
      ) : null}
    </section>
  );
}

const admissionProcessSteps = [
  {
    n: "01",
    t: "Fill the Enrollment Form",
    d: "Share your basic details to begin your application with IPDI.",
  },
  {
    n: "02",
    t: "Block Your Seat",
    d: "Reserve your seat in the program with a nominal advance payment.",
  },
  {
    n: "03",
    t: "Complete Your Admission Form",
    d: "Complete your admission form and submit all required documents.",
  },
  {
    n: "04",
    t: "Complete the Payment",
    d: "Clear the balance program fee to confirm your enrollment.",
  },
  {
    n: "05",
    t: "Get Your Login Details",
    d: "Receive your login ID and password to start your online program.",
  },
];

function AdmissionProcessSection() {
  return (
    <section className="adm-process">
      <style>{`
        .adm-process {
          padding: 5rem 4rem 5rem 2.5rem;
          max-width: 1180px;
          margin: 0 ;
        }
        .adm-process-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 1.8rem;
          margin-top: 3rem;
          position: relative;
        }
        .adm-process-grid::before {
          content: "";
          position: absolute;
          top: 26px;
          left: 5%;
          right: 5%;
          height: 2px;
          background: repeating-linear-gradient(
            to right,
            var(--sand, #e7e1d8) 0px,
            var(--sand, #e7e1d8) 6px,
            transparent 6px,
            transparent 12px
          );
          z-index: 0;
        }
        .adm-step {
          background: #fff;
          border: 1px solid var(--sand, #e7e1d8);
          border-radius: 10px;
          padding: 2rem 1.5rem 1.8rem;
          position: relative;
          z-index: 1;
          transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
        }
        .adm-step:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(28, 26, 23, 0.12);
          border-color: #c84b20;
        }
        .adm-step-badge {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: var(--charcoal, #1c1a17);
          color: #f4efe6;
          font-family: var(--serif);
          font-size: 1.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.3rem;
          transition: background 0.35s ease, transform 0.35s ease;
          position: relative;
        }
        .adm-step:hover .adm-step-badge {
          background: #c84b20;
          transform: scale(1.08);
        }
        .adm-step-t {
          font-weight: 600;
          font-size: 0.95rem;
          color: var(--charcoal, #1c1a17);
          line-height: 1.4;
          transition: color 0.3s ease;
        }
        .adm-step:hover .adm-step-t {
          color: #c84b20;
        }
        .adm-step-d {
          margin-top: 0.6rem;
          font-size: 0.82rem;
          color: var(--stone, #7d766c);
          font-weight: 300;
          line-height: 1.6;
        }
        @media (max-width: 900px) {
          .adm-process-grid { grid-template-columns: repeat(2, 1fr); }
          .adm-process-grid::before { display: none; }
        }
        @media (max-width: 560px) {
          .adm-process-grid { grid-template-columns: 1fr; }
          .adm-process { padding: 3rem 1.25rem 2rem; }
        }
        @media (min-width: 1600px) {
          .adm-process {
            max-width: 1400px;
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
      <div className="eyebrow rv">
        <div className="eyebrow-dash" />
        <span className="eyebrow-text">Simple &amp; Fast</span>
      </div>
      <h2 className="sec-title rv d1">
        Admission <em>Process</em>
      </h2>
      <div className="adm-process-grid">
        {admissionProcessSteps.map((step) => (
          <div className="adm-step" key={step.n}>
            <div className="adm-step-badge">{step.n}</div>
            <div className="adm-step-t">{step.t}</div>
            <div className="adm-step-d">{step.d}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

// Data for the "Why This Program Is Different" cards — Customize Your Program.
const diffCardsCustomize = [
  {
    old: "One fixed syllabus for everyone",
    new: "You choose your own modules",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 20l9-16H3l9 16z" />
      </svg>
    ),
  },
  {
    old: "Pay for topics you don't need",
    new: "Pay only for what you select",
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 9h18" />
      </svg>
    ),
  },
  {
    old: "Software-focused",
    new: "Complete, career-relevant skillset",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
      </svg>
    ),
  },
  {
    old: "Classroom assignments",
    new: "Live industry exposure",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
        <path d="M6 12v5c3 3 9 3 12 0v-5" />
      </svg>
    ),
  },
  {
    old: "Generic teaching",
    new: "Mentorship from practicing architects",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
      </svg>
    ),
  },
  {
    old: "Certificate-oriented",
    new: "Career and practice readiness",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M12 15l-2 5 2-1 2 1-2-5z" />
        <circle cx="12" cy="8" r="6" />
      </svg>
    ),
  },
];

// "Why This Program Is Different" section — rendered right after the
// module builder (CourseOverview), before Key Highlights. (Customize Your Program page)
function WhyDifferentSectionCustomize() {
  return (
    <section className="ipcw" id="why-different">
      <style>{`
        .ipcw {
          max-width: 1400px;
          margin: 0 auto;
          padding: 4rem 2.5rem 6rem;
        }
        .ipcw-hdr {
          max-width: 66ch;
          margin-bottom: 3rem;
        }
        .ipcw-hdr .sec-sub {
          margin-top: 1rem;
          color: var(--stone);
          font-size: 0.95rem;
          font-weight: 300;
          line-height: 1.8;
        }

        .ipcw-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 15px;
          // background: var(--sand);
        }
        .ipcw-card {
          background: #fff;
          padding: 2.2rem 2rem;
          display: flex;
          flex-direction: column;
          gap: 1rem;
          transition: background 0.3s;
        }
        .ipcw-card:hover {
          background: var(--cream);
        }
        .ipcw-icon {
          width: 2.4rem;
          height: 2.4rem;
          background: rgba(184, 92, 40, 0.12);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ipcw-icon svg {
          width: 14px;
          height: 14px;
          stroke: var(--terra);
          fill: none;
          stroke-width: 1.8;
        }
        .ipcw-old-line {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.78rem;
          color: var(--stone-lt);
          font-weight: 300;
          text-decoration: line-through;
          text-decoration-color: var(--sand);
        }
        .ipcw-new-line {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.95rem;
          color: var(--charcoal);
          font-weight: 600;
        }

        @media (max-width: 900px) {
          .ipcw-cards {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media (max-width: 700px) {
          .ipcw {
            padding: 5rem 1.3rem 3.5rem;
          }
          .ipcw-hdr {
            margin-bottom: 2rem;
          }
          .ipcw-cards {
            grid-template-columns: 1fr;
          }

.ipcw-cards {
            padding: 1rem 0 1.2rem 0;}
          }

        }
      `}</style>

      <div className="ipcw-hdr rv">
        <div className="eyebrow">
          <div className="eyebrow-dash" />
          <span className="eyebrow-text">The Difference</span>
        </div>
        <h2 className="sec-title">
          Why This Program Is <em>Different</em>
        </h2>
        <p className="sec-sub">
          Most training forces everyone through the same syllabus. We built a
          program you can shape yourself — pick the modules that match where
          you are and where you want to go next.
        </p>
      </div>

      <div className="ipcw-cards rv d1">
        {diffCardsCustomize.map((card) => (
          <div className="ipcw-card" key={card.old}>
            <div className="ipcw-icon" aria-hidden="true">
              {card.icon}
            </div>
            <div className="ipcw-old-line">{card.old}</div>
            <div className="ipcw-new-line">{card.new}</div>
          </div>
        ))}
      </div>
    </section>
  );
}


function ChevronIcon({ open }) {
  if (open) {
    return (
      <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 12L12 2L2 12" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 2L12 12L2 2" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function CustomizeYourProgramPage() {
  const [openHighlight, setOpenHighlight] = useState(0);
  const [activeTab, setActiveTab] = useState(getTabFromHash);
  const [activeSteps, setActiveSteps] = useState(1);

  // Selection totals now come from <CourseOverview />, via onTotalChange,
  // so the fee shown in the Overview / Admissions tabs stays in sync with
  // whatever the user picked in the "Customize Program" tab.
  const [builderTotal, setBuilderTotal] = useState(0);
  const [builderModuleCount, setBuilderModuleCount] = useState(0);
  // FIX: these two were missing before, which is why nothing selected in
  // the builder ever reached the backend — CustomizeAdmissionForm's
  // `selectedModules`/`selectedBreakdown` props always fell back to their
  // empty defaults.
  const [builderSelectedNames, setBuilderSelectedNames] = useState([]);
  const [builderBreakdown, setBuilderBreakdown] = useState({
    courseNames: [],
    softwareNames: [],
    courseFee: 0,
    softwareFee: 0,
  });

  const revealRef = useRef(null);
  const lpeTimerRef = useRef(null);
  const lpeAnimatedRef = useRef(false);
  const tabsWrapRef = useRef(null);
  const tabsSentinelRef = useRef(null);
  const [tabsPinned, setTabsPinned] = useState(false);
  const [tabsHeight, setTabsHeight] = useState(0);
  // Guards the scroll-spy from fighting a click-triggered smooth scroll.
  const isProgrammaticScrollRef = useRef(false);
  const programmaticScrollTimerRef = useRef(null);

  useEffect(() => {
    document.title = "Customize Your Program - IPDI";
  }, []);

  useEffect(() => {
    const getHeaderOffset = () =>
      window.matchMedia("(max-width: 700px)").matches ? 56 : 64;

    const updateTabsState = () => {
      if (!tabsSentinelRef.current || !tabsWrapRef.current) {
        return;
      }
      setTabsHeight(tabsWrapRef.current.offsetHeight);
      setTabsPinned(tabsSentinelRef.current.getBoundingClientRect().top <= getHeaderOffset());
    };

    updateTabsState();
    window.addEventListener("scroll", updateTabsState, { passive: true });
    window.addEventListener("resize", updateTabsState);
    return () => {
      window.removeEventListener("scroll", updateTabsState);
      window.removeEventListener("resize", updateTabsState);
    };
  }, []);

  useEffect(() => {
    const onPopState = () => {
      setActiveTab(getTabFromHash());
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  // Reveal animation — runs once on mount now that every section is always in the DOM.
  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".rv"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  // LPE stepper — runs once on mount (overview section is always mounted now).
  useEffect(() => {
    lpeAnimatedRef.current = false;
    setActiveSteps(1);

    const stepper = revealRef.current;
    if (!stepper) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !lpeAnimatedRef.current) {
            lpeAnimatedRef.current = true;
            let index = 1;
            lpeTimerRef.current = window.setInterval(() => {
              if (index < 4) { index += 1; setActiveSteps(index); }
              else window.clearInterval(lpeTimerRef.current);
            }, 450);
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(stepper);
    return () => {
      observer.disconnect();
      if (lpeTimerRef.current) window.clearInterval(lpeTimerRef.current);
    };
  }, []);

  // Scroll-spy — keeps the tab bar's active/underline state in sync while the
  // user scrolls the single long page, instead of switching content in/out.
  useEffect(() => {
    const sections = VALID_TABS.map((id) => document.getElementById(id)).filter(Boolean);
    if (sections.length === 0) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (isProgrammaticScrollRef.current) return;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveTab(entry.target.id);
          }
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 }
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  // Scrolls smoothly to a section id on this same page, accounting for the
  // pinned tabs bar height, and marks that tab active immediately (the
  // scroll-spy observer takes back over once the smooth scroll settles).
  const scrollToSection = (tabId) => {
    const targetEl = document.getElementById(tabId);
    if (!targetEl) return;

    const getHeaderOffset = () =>
      window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
    const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
    const top =
      targetEl.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - tabsOffset;

    isProgrammaticScrollRef.current = true;
    window.scrollTo({ top, behavior: "smooth" });

    if (programmaticScrollTimerRef.current) {
      window.clearTimeout(programmaticScrollTimerRef.current);
    }
    programmaticScrollTimerRef.current = window.setTimeout(() => {
      isProgrammaticScrollRef.current = false;
    }, 900);
  };

//   const openAdmissionsForm = () => {
//     setActiveTab("admissions");
//     window.history.pushState(null, "", "#admissions");
//     window.requestAnimationFrame(() => {
//       const target = document.getElementById("apply") || document.getElementById("admissions");
//       if (!target) return;

//       const headerOffset = window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
//       const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
//       const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - tabsOffset - 18;

//       isProgrammaticScrollRef.current = true;
//       window.scrollTo({ top, behavior: "smooth" });

//       if (programmaticScrollTimerRef.current) {
//         window.clearTimeout(programmaticScrollTimerRef.current);
//       }
//       programmaticScrollTimerRef.current = window.setTimeout(() => {
//         isProgrammaticScrollRef.current = false;
//       }, 900);
//     });
//   };


const openAdmissionsForm = () => {
  setActiveTab("enroll");
  window.history.pushState(null, "", "#enroll");
  window.requestAnimationFrame(() => {
    const target = document.getElementById("apply") || document.getElementById("enroll");
    if (!target) return;

    const headerOffset = window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
    const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - tabsOffset - 18;

    isProgrammaticScrollRef.current = true;
    window.scrollTo({ top, behavior: "smooth" });

    if (programmaticScrollTimerRef.current) {
      window.clearTimeout(programmaticScrollTimerRef.current);
    }
    programmaticScrollTimerRef.current = window.setTimeout(() => {
      isProgrammaticScrollRef.current = false;
    }, 900);
  });
};

  // The "Enroll" tab is a shortcut, not a real scroll-spy section — clicking
  // it jumps straight to the admission form (same target as "Start
  // Application" / "Apply") instead of scrolling to a dedicated #enroll block.
  const handleTabClick = (event, tabId) => {
    event.preventDefault();

    if (tabId === "enroll") {
      openAdmissionsForm();
       setActiveTab("enroll");
      return;
    }

    setActiveTab(tabId);
    window.history.pushState(null, "", `#${tabId}`);
    scrollToSection(tabId);
  };

  // On first load, if the URL already has a hash (e.g. shared link to
  // #admissions), jump straight to that section once everything is mounted.
  useEffect(() => {
    const initialTab = getTabFromHash();
    if (initialTab === "overview") return;
    const targetEl = document.getElementById(initialTab);
    if (!targetEl) return;

    const getHeaderOffset = () =>
      window.matchMedia("(max-width: 700px)").matches ? 56 : 64;
    const tabsOffset = tabsWrapRef.current ? tabsWrapRef.current.offsetHeight : 0;
    const top =
      targetEl.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - tabsOffset;

    window.scrollTo({ top, behavior: "auto" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


 

  // FIX: now also receives + stores selectedNames and the courses/software
  // breakdown coming from <CourseOverview />, instead of dropping them.
  const handleBuilderTotalChange = (total, moduleCount, selectedNames, breakdown) => {
    setBuilderTotal(total);
    setBuilderModuleCount(moduleCount);
    setBuilderSelectedNames(selectedNames || []);
    setBuilderBreakdown(
      breakdown || { courseNames: [], softwareNames: [], courseFee: 0, softwareFee: 0 }
    );
  };

  const hasSelectedModules = builderModuleCount > 0;
  const selectedFee = hasSelectedModules ? `INR ${builderTotal.toLocaleString()} /-` : "as per module";

  return (
    <main className="public-page architect-theme customize-page">
     
     
      <section className="chero customize-chero">
        <style>{`
          /* Large/big PC monitor only — same breakpoint used for the
             site-wide full-bleed + contained-content fix. Restores the
             vertical (Y) offset on the hero info-bar that the shared
             1600px+ centering rule overwrites (it only sets
             translateX(-50%) for horizontal centering, dropping the
             translateY(50%) the base style relies on for the
             hero/content overlap). Losing that Y-offset was pulling the
             info-bar up over the "Enroll Now" button and misaligning it. */
          @media (min-width: 1600px) {
            .architect-theme .customize-chero .info-bar {
              transform: translate(-50%, 50%);
            }
          }
        `}</style>
        <div className="chero-grid" />
        <div className="chero-glow" />
        <div className="chero-inner">
          <div className="chero-kicker rv d1 " style={{ color: "#c84b20" }}>
            Professional Training Program
          </div>
          <div className="chero-title-wrap rv d2">
            <div className="chero-title-bar" />
            <h1 className="chero-title">
              Customize your
             
              <span style={{  color: "#c84b20" }}> Program</span>
            </h1>
          </div>

<p class="chero-italic rv d3 ">Build a Path That Fits Your Career</p>

          <p className="chero-sub rv d4 ">
            Unlock your potential Upgrade your skills and Be Deserve for the next Position
          </p>
          <div className="chero-actions" style={{ marginBottom: "2.2rem" }}>
            <button
              type="button"
              className="btn btn-terra"
              onClick={openAdmissionsForm}
            >
              Start your Application

              <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2" width="13" height="13">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </button>
            <div className="chero-soon">
              <span className="chero-soon-dot" />
              Starting : 01-07-2026
            </div>
          </div>
        </div>

        <div className="info-bar">
          <div className="info-item">
            <div className="info-icon">
              <HeroIcon type="eligibility" />
            </div>
            <div className="info-lbl">Eligibility</div>
            <div className="info-val">B.Arch + 1 year Experience</div>
          </div>
          <div className="info-item">
            <div className="info-icon">
              <HeroIcon type="duration" />
            </div>
            <div className="info-lbl">Duration</div>
            <div className="info-val">as per module</div>
            <div className="info-sub">Recommended 15 hrs/week</div>
          </div>
          <div className="info-item">
            <div className="info-icon">
              <HeroIcon type="classes" />
            </div>
            <div className="info-lbl">Classes</div>
            <div className="info-val">Virtual Classrooms</div>
            <div className="info-sub">Live interactions and coaching</div>
          </div>
        </div>
      </section>

      <div ref={tabsSentinelRef} className="tabs-sentinel" />
      <div
        className={`tabs-wrap customize-tabs${tabsPinned ? " is-tabs-fixed" : ""}`}
        ref={tabsWrapRef}
      >
        <div className="tabs">
          {customizeTabs.map(([id, label]) => (
            <a
              key={id}
              className={`tab-link${activeTab === id ? " active" : ""}`}
              href={`#${id}`}
              onClick={(event) => handleTabClick(event, id)}
            >
              {label}
            </a>
          ))}
        </div>
      </div>
      <div className="tabs-spacer" style={{ height: tabsPinned ? tabsHeight : 0 }} />

      {/* ══════════════════════════════════════
          OVERVIEW SECTION — always rendered
      ══════════════════════════════════════ */}


      <div id="overview">
       {/* Key Highlights */}
        <section className="highlights hl-highlights-section">


  <style>{`
              .hl-highlights-grid {
                display: flex;
                gap: 60px;
                align-items: start;
              }

              /* ── Column 1: Key Highlights (70%) ── */
              .hl-highlights-section .hl-accordion {
                flex: 0 0 calc(65% - 0.875rem);
                width: auto;
                max-width: 100%;
                box-sizing: border-box;
              }
              .hl-highlights-section .hl-item,
              .hl-highlights-section .hl-q,
              .hl-highlights-section .hl-a {
                box-sizing: border-box;
                max-width: 100%;
              }
              .hl-highlights-section .hl-item:first-child .hl-a-inner {
                max-width: none;
              }

              /* ── Column 2: At a Glance (30%) ── */
              .hl-at-glance {
                flex: 0 0 calc(30% - 0.875rem);
                width: auto;
                background: #fdfcfa;
                border: 1px solid var(--sand);
                padding: 2.2rem 2rem;
                margin-top: 105px;
              }
              .hl-at-glance-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
              .hl-at-glance-eyebrow {
                font-family: var(--mono);
                font-size: 0.78rem;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: var(--terra);
              }
              .hl-at-glance-pulse {
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background: var(--terra);
                animation: ipdw-pulse 1.8s ease-in-out infinite;
              }
              @keyframes ipdw-pulse {
                0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(184,92,40,0.5); }
                50% { opacity: 0.6; box-shadow: 0 0 0 5px rgba(184,92,40,0); }
              }
              .hl-at-glance-row {
                display: flex;
                align-items: flex-start;
                gap: 1rem;
                padding: 1.2rem 0;
                border-bottom: 1px solid var(--cream);
              }
              .hl-at-glance-row:last-child { border-bottom: none; }
              .hl-at-glance-icon {
                flex-shrink: 0;
                width: 40px;
                height: 40px;
                background: rgba(184, 92, 40, 0.1);
                border: 1px solid rgba(184, 92, 40, 0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--terra);
              }
              .hl-at-glance-icon svg { width: 18px; height: 18px; }
              .hl-at-glance-title {
                font-size: 0.98rem;
                font-weight: 600;
                color: var(--charcoal);
                margin-bottom: 0.3rem;
              }
              .hl-at-glance-sub {
                font-size: 0.8rem;
                font-weight: 300;
                color: var(--stone);
                line-height: 1.45;
              }

              /* ── Stack into one column on smaller screens ── */
              @media (max-width: 760px) {
                .hl-highlights-grid {
                  flex-direction: column;
                }
                .hl-highlights-section .hl-accordion {
                  flex: 1 1 100%;
                  width: 100%;
                  max-width: 100%;
                }
                .hl-at-glance {
                  flex: 1 1 100%;
                  width: 100%;
                }
              }

              /* =====================================================
                 Key Highlights — Mobile view only (<=700px)
                 Desktop rules above are untouched.
              ===================================================== */
              @media (max-width: 700px) {
                .architect-theme .hl-highlights-section {
                  width: 100%;
                  max-width: 100%;
                  padding-top: 3rem;
                  padding-left: 0;
                  padding-right: 0;
                }
                .architect-theme .hl-highlights-section .hl-head {
                  max-width: 100%;
                  padding-left: 1rem;
                  padding-right: 1rem;
                  box-sizing: border-box;
                }
                .architect-theme .hl-highlights-section .hl-accordion {
                  width: 100%;
                  max-width: 100%;
                  padding-left: 1rem;
                  padding-right: 1rem;
                }
                .architect-theme .hl-highlights-section .hl-q-text {
                  font-size: 0.92rem;
                }
                .architect-theme .hl-highlights-section .hl-a-inner {
                  max-width: 100%;
                  font-size: 0.82rem;
                }
                .architect-theme .hl-highlights-section .hl-item.open .hl-a {
                  max-height: 1400px !important;
                }
                .architect-theme .hl-highlights-section .hl-stat-grid {
                  grid-template-columns: 1fr;
                }
                .architect-theme .hl-highlights-section .hl-stat-cell {
                  padding: 1.4rem 1.5rem;
                  min-height: unset;
                }
                .architect-theme .hl-highlights-section .hl-stat-label {
                  white-space: normal;
                }
                .architect-theme .hl-at-glance {
                  margin-top: 0.1rem;
                }
              }

              .chero-italic {
                font-family: var(--serif);
                font-style: italic;
                font-size: clamp(1.15rem, 1.8vw, 1.5rem);
                font-weight: 400;
                color: #c84b20;
                margin-bottom: 2px;
              }
            `}</style>

          <div className="hl-head" style={{ maxWidth: "860px" }}>
            <div className="eyebrow rv">
              <div className="eyebrow-dash" />
              <span className="eyebrow-text">Why This Program</span>
            </div>
            <h2 className="sec-title rv d1" >
              Key <em>Highlights</em>
            </h2>
          </div>

          <div className="hl-highlights-grid">
            <div className="hl-accordion rv d3">
              {highlights.map((item, index) => {
                const isOpen = item.alwaysOpen || openHighlight === index;
                const openHeight = HL_OPEN_HEIGHTS[index];
                return (
                  <div className={`hl-item${isOpen ? " open" : ""}`} key={item.title}>
                    <button
                      type="button"
                      className="hl-q"
                      onClick={() => {
                        if (item.alwaysOpen) return;
                        setOpenHighlight(isOpen ? -1 : index);
                      }}
                    >
                      <span className="hl-q-text">{item.title}</span>
                      <div className="hl-icon" style={{ transform: "none" }}>
                        <ChevronIcon open={isOpen} />
                      </div>
                    </button>
                    <div
                      className="hl-a"
                      style={openHeight ? { maxHeight: isOpen ? `${openHeight}px` : undefined } : {}}
                    >
                      <div className="hl-a-inner">{item.detail}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

 <DesignedForPractice />

   {/* Why This Program Is Different */}
        <WhyDifferentSectionCustomize />


        {/* Customize Program — now shown inline inside Overview, just below Course Overview */}
        <div id="customize" className="customize-wrap">
          <style>{`
            .customize-wrap {
              // padding: 1rem 1.5rem;
              background: #f7f4ef;
            }
            @media (max-width: 700px) {
              .customize-wrap {
                padding-left: 0;
                padding-right: 0;
              }
            }
          `}</style>
          <CourseOverview onApply={openAdmissionsForm} onTotalChange={handleBuilderTotalChange} />
        </div>



        {/* ══════════════════════════════════════
         45days Live Project SECTION —
      ══════════════════════════════════════ */}

       <LiveProjectSection showDaysBadge={false} />


           {/* ══════════════════════════════════════
          INSTRUCTORS SECTION — always rendered
      ══════════════════════════════════════ */}
      <div id="instructors">
        <Trainers />
      </div>


           {/* Growth */}
       <section className="growth" id="outcome">
          <div className="growth-inner">
            <div className="growth-hdr">
              <div className="rv">
                <div className="eyebrow">
                  <div className="eyebrow-dash" />
                  <span className="eyebrow-text">Growth</span>
                </div>

                <h2 className="sec-title lt"> How This Program Transforms You </h2>
              </div>
              <div className="growth-desc rv d1">
                <p>  More than technical training, this program prepares you to think, work, and perform like a professional architect. Through personalized mentoring, real-world exposure, and industry-driven learning, you'll build the confidence to take on real architectural challenges. </p>
              </div>
            </div>
            <div className="growth-grid rv d2">
              {growthCards.map((card) => (
                <div className="gc" key={card.title}>
                  <div className="gc-icon">{card.icon}</div>
                  <div className="gc-t">{card.title}</div>
                  <p className="gc-d">{card.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

         <Outcomes />

<CertificateOutcomeSection />

      </div>

     
      {/* ══════════════════════════════════════
          ADMISSIONS SECTION — always rendered
      ══════════════════════════════════════ */}
      {/* <div id="admissions">
        <AdmissionProcessSection />
        <CustomizeAdmissionForm
          sectionId="admissions"
          selectedCount={builderModuleCount}
          selectedFee={selectedFee}
          hasSelectedModules={hasSelectedModules}
          onStartApplication={openAdmissionsForm}
          selectedModules={builderSelectedNames}
          selectedBreakdown={builderBreakdown}
          reveal
        />
      </div> */}


<div id="admissions">
  <AdmissionProcessSection />
</div>
<CustomizeAdmissionForm
  sectionId="enroll"
  selectedCount={builderModuleCount}
  selectedFee={selectedFee}
  hasSelectedModules={hasSelectedModules}
  onStartApplication={openAdmissionsForm}
  selectedModules={builderSelectedNames}
  selectedBreakdown={builderBreakdown}
  reveal
/>
</main>
  );
}    

export default CustomizeYourProgramPage;

